export const DATA_OPTIONS = [
    {value: "AUDIT_POLICIES", label: "Audit policies"},
    {value: "DEVICES", label: "Devices"},
    {value: "FILE_SERVERS", label: "File servers"},
    {value: "FILES", label: "Files "},
    {value: "OS_PLANS", label: "OS plans"},
    {value: "SCHEDULES", label: "Schedules"},
];

export const AUDIT_OPTIONS = [{value: "lastAuditStatus", label: "Status"}];

export const DEVICES_OPTIONS = [
    {value: "capturedBy", label: "Captured By", sln: "ConfigDrift"},
    {value: "auditStatus", label: "Audit Status", sln: "ConfigDrift"},
    {value: "lastAuditPolicy", label: "Audit Policy", sln: "ConfigDrift"},
    {value: "auditedBy", label: "Audited By", sln: "ConfigDrift"},
    {value: "latestHaveIChanged", label: "Captured Status", sln: "ConfigDrift"},
    {value: "osUpgradeStatus", label: "OS Upgrade Status", sln: "OSManager"},
    {value: "osUpgradedBy", label: "OS Upgraded By", sln: "OSManager"},
    {value: "osUpgradePlanName", label: "OS Upgrade Plan Name", sln: "OSManager"},
    {value: "osUpgradePlanAction", label: "OS Upgrade Plan Action", sln: "OSManager"},
];

export const FILE_SERVER_OPTIONS = [{value: "status", label: "Status"}];

export const FILE_OPTIONS = [
    {value: "fileType", label: "File type"},
    {value: "imageType", label: "Image"},
    {value: "status", label: "Status"},
    {value: "vendor", label: "Vendor"},
];

export const OS_PLANS_OPTIONS = [
    {value: "action", label: "Action"},
    {value: "status", label: "Plan status"},
];

export const SCHEDULES_OPTIONS = [
    {value: "lastOccurrenceStatus", label: "Schedule status"},
    {value: "schedule.type", label: "Schedule type"},
    {value: "solution", label: "Solution"},
];

export const CHART_TYPE_OPTIONS = [
    {value: "Doughnut", label: "Doughnut", cutout: 50},
    {value: "Pie", label: "Pie", cutout: 0},
];

export const REGEX_PARAMS = [
    "discoveredBy",
    "lastActivityBy",
    "lastActivityError",
    "lastActivityType",
    "detectedSerialNumber",
    "detectedSku",
    "detectedSoftwareVersion",
    "capturedBy",
    "lastAuditPolicy",
    "auditedBy",
    "osUpgradedBy",
    "osUpgradePlanName",
    "osUpgradePlanAction",
];
